import { useState } from "react"

import { ProjectFormTabType } from "features/project-management/types/ProjectFormTabType"
import { useSharedProject } from "features/project-sharing/model/useSharedProject"
import { ProjectPageProjectSidebarModel } from "pages/project-page/sidebar/project/ProjectPageProjectSidebar"

const noop = () => undefined

export function useSharedProjectPageProjectSidebarModel({
  projectID: projectShareID
}: {
  projectID: string
}): ProjectPageProjectSidebarModel {
  const [sidebarActiveTab, setSidebarActiveTab] = useState<string | null>(null)
  const model = useSharedProject(
    { projectShareID },
    {
      includePrice: sidebarActiveTab === ProjectFormTabType.PRICES,
      includeAttachments: true
    }
  )

  return {
    projectID: projectShareID,
    model,
    isEditing: false,
    enterEditing: noop,
    exitEditing: noop,
    sidebarActiveTab,
    setSidebarActiveTab
  }
}
